import { Badge } from '@chakra-ui/react'
import { ReactNode } from 'react'

interface ITabErrorLabelProps {
  label: ReactNode
  /** Errors sitting in the tab; the badge shows only above zero. */
  count: number
}

/** A tab's label with the number of errors it holds, so a refused save points at the tab to open. */
export function TabErrorLabel({ label, count }: ITabErrorLabelProps) {
  return (
    <>
      {label}
      {count > 0 && (
        <Badge ml={2} colorScheme="red">
          {count}
        </Badge>
      )}
    </>
  )
}
